import { BriefcaseBusiness } from "lucide-react";
import i18n from "i18next";

const manifest = {
  key: "tenders_offers_management",
  isFreeModule: false,
  isPurchasable: true,
  bundles: ["preferred_vendors_management"],
  icon: BriefcaseBusiness,
  names: {
    plan: {
      en: "Tenders & Offers Management",
      ar: i18n.t("menu_tenders_offers_management"),
      "zh-Hans": "招标与报价管理",
    },
    dashboard: {
      en: "Create Tender",
      ar: "طرح المنافسات",
      "zh-Hans": "创建招标",
    },
  },
  defaultPath: "/tenders-dashboard",
  matchers: [
    /^\/tenders-dashboard(?:\/|$)/,
    /^\/tender-form(?:\/|$)/,
    /^\/my-tenders(?:\/|$)/,
    /^\/all-tenders(?:\/|$)/,
    /^\/mytender\/[^/]+(?:\/|$)/,
    /^\/report\/tender\/[^/]+\/offers-analysis(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel, ALL_TENDERS_ENABLED }) => [
    {
      label: activeModuleLabel,
      path: "__tender_management__",
      children: [
        { label: t("dashboard"), path: "/tenders-dashboard" },
        {
          label: t("menu_create_tender") || t("TenderForm"),
          path: "/tender-form",
          permissions: ["create_tender", "publish_tender"],
        },
        {
          label: t("MyTenders"),
          path: "/my-tenders",
          permissions: ["view_published_tenders", "view_my_submitted_competitions"],
        },
        {
          label: t("All_Tenders"),
          path: "/all-tenders",
          permissions: ["view_published_tenders"],
        },
        {
          label:
            t("menu_negotiation_award_management") ||
            "Negotiation and Award Management",
          path: "/negotiation-dashboard",
          permissions: ["view_pending_supplier_negotiations", "award_supplier"],
        },
        {
          label:
            t("menu_preferred_vendors_management") || "Preferred Vendors Management",
          path: "/preffered-supplier",
          permissions: ["manage_preferred_vendors"],
        },
        {
          label:
            t("menu_incoming_offers_price_analysis") || "Incoming Offers & Price Analysis",
          path: "/received-proposals",
          permissions: ["manage_approvals_requests"],
        },
        {
          label:
            t("menu_approvals_requests_management") || "Approvals and Requests Management",
          path: "/approvals-dashboard",
          permissions: ["manage_approvals_requests"],
        },

      ],
    },
  ],
};

export default manifest;
